export { SkillTeamPlayer as default } from './SkillTeamPlayer';
